import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import LocationMap from "./Modal";
import cImg1 from "../../images/coming.jpg";

const InvitationPage1: React.FC = () => {
  return (
    <Fragment>
      <Navbar hclass="header-style-s2" />
      <section
        className="wpo-invitation-area"
        style={{
          background: `url(${cImg1}) no-repeat center center`,
          backgroundSize: "cover",
        }}
      >
        <div className="hero-container">
          <div className="hero-inner">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-12">
                  <div
                    className="wpo-event-wrap wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div className="wpo-event-item">
                      <div className="wpo-event-text">
                        <h2>Wilson & Amanda</h2>
                        <p>Our Big Day is November 15, 2025</p>
                        <ul>
                          <li>
                            Monday, 12 Apr. 2025 <br />
                            1:00 PM – 2:30 PM
                          </li>
                          <li>4517 Washington Ave. Manchester, Kentucky 39495</li>
                          <li>+1 234-567-8910</li>
                          <li>
                            <LocationMap />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default InvitationPage1;
